import React, { useEffect } from "react";
import Banner from "./Banner";
import NavigationTab from "./NavigationTab";
import { useLocation } from "react-router-dom";
import { IOffer } from "./Types";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";

function SalesLandingStep1() {
    const search = useLocation().search;
    const offerName = new URLSearchParams(search).get("offer");
    const RetailerCode: any = new URLSearchParams(search).get("RetailerCode") || new URLSearchParams(search).get("RETAILERCODE");
    const offerData: IOffer = {
        offerName: offerName,
        retailerCode: RetailerCode,
    };
    const isTransunionIDFPartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2649
                ? true
                : false
            : false
    );
    const isOfferPartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2617
                ? true
                : false
            : false
    );
    const originSiteUrl = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.originSiteUrl
            ? state.configurationState.configuration.partnerConfig.originSiteUrl
            : ""
    );

    useEffect(() => {
        if (isTransunionIDFPartner || isOfferPartner) {
            window.location.href = `https://${originSiteUrl}`;
        }
        window.scrollTo(0, 0);
        window.targetView("SQ-Funnel-salesLanding-Page-View");
    }, []);

    return (
        <>
            <Banner offer={offerData} />
            <NavigationTab offer={offerData} />
        </>
    );
}

export default SalesLandingStep1;
